import { render, staticRenderFns } from "./InstitutionCreate.vue?vue&type=template&id=11295fa7&"
import script from "./InstitutionCreate.vue?vue&type=script&lang=js&"
export * from "./InstitutionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports